import styled from "@emotion/styled";
import { makeStyles } from "@material-ui/core/styles";
import { theme } from "@styles/theme";
const { sm, md, lg, xl } = theme.breakpoints;
export const Container = styled.div`
  .MuiTimelineItem-missingOppositeContent:before {
    flex: 0 !important;
  }
  .MuiTimelineItem-root {
    width: 48% !important;
  }
  @media (max-width: ${sm}) {
    .MuiTimelineItem-missingOppositeContent:before {
      flex: 0 !important;
      padding: 0;
    }
    .MuiTimelineItem-root {
      width: 100% !important;
    }
  }
`;
export const Time = styled.div`
  font-size: 1em;
  margin-bottom: 1em;
  font-family: "Poppins Medium";
`;
export const Content = makeStyles({
  root: {
    flex: 1,
    padding: "6px 18px",
    fontFamily: "Poppins Ligth",
    fontSize: "0.9em",
    color: "#6F7072",
  },
});
export const Dot = makeStyles({
  root: {
    display: "flex",
    padding: "4px",
    alignSelf: "baseline",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    marginTop: "8px",
    borderStyle: "solid",
    borderWidth: "2px",
    borderRadius: "50%",
    marginBottom: "8px",
    backgroundColor: "#90D1F4",
  },
});
